(function($) {
    function setBarStatus() {
        const status = $('#bar-status');
        const info = window.mypubs.getBarStatus(status);
        const statusClass = info.isClosingSoon ? 'status-pill-soon' : info.isOpen ? 'status-pill-open' : 'status-pill-closed';
        const statusText = info.isClosingSoon ? "\u0421\u043A\u043E\u0440\u043E \u0437\u0430\u043A\u0440\u043E\u0435\u0442\u0441\u044F" : info.isOpen ? "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u0441\u0435\u0439\u0447\u0430\u0441" : "\u0417\u0430\u043A\u0440\u044B\u0442\u043E";
        status.removeClass('status-pill-open status-pill-closed status-pill-soon').addClass(statusClass).text(statusText);
    }
    function setMarker() {
        const name = $('#bar-name').text();
        const icon = $('#map-marker').data('src');
        const [lat, lng] = $('#map-location').val().split(',').map(Number);
        const map = L.map('map').setView([
            lat,
            lng
        ], 15);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; OSM'
        }).addTo(map);
        const marker = icon ? L.icon({
            iconUrl: icon,
            iconSize: [
                40,
                40
            ],
            iconAnchor: [
                20,
                40
            ],
            popupAnchor: [
                0,
                -40
            ]
        }) : new L.Icon.Default();
        L.marker([
            lat,
            lng
        ], {
            icon: marker
        }).addTo(map).bindPopup(name);
        $('.leaflet-control-attribution a, .leaflet-control-attribution span').hide();
    }
    function setRating() {
        var url = location.href.replace(location.hash, "");
        var container = $('#bar-rating');
        window.mypubs.getRating(url, container);
    }
    setBarStatus();
    setMarker();
    setRating();
})(jQuery);

//# sourceMappingURL=pub.883e2667.js.map
